import { useGetOGPUserInfo } from 'ogp/hooks';
import { hasAccessWithinPolicyGroup, PolicyGroups } from 'shared/utils/policy-controller';
import { BranchOfficeRole } from 'types/roles/BranchOfficeRole';

export const useIsOgpManager = () => {
  const userQuery = useGetOGPUserInfo();

  const isOgpManager =
    userQuery.data &&
    hasAccessWithinPolicyGroup(
      PolicyGroups.DEPARTMENT,
      userQuery.data.userInfo,
      BranchOfficeRole.MANAGER
    );
  return isOgpManager ?? false;
};
